function InfoButton({ className, ...props }) {
  return (
    <button
      className={`w-4 h-4 bg-[#DADDE3] justify-center items-center rounded-full text-white inline-flex ${className}`}
      {...props}
    >
      i
    </button>
  );
}

export default InfoButton;
